import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import CustomerEngagement from "./assets/img/CustomerEngagement.png";
import WebsiteDevelopment from "./assets/img/WebsiteDevelopment.png";
import WorkflowAutomation from "./assets/img/WorkflowAutomation.png";
import SearchEngineOptimization from "./assets/img/SearchEngineOptimization.png";
import SocialMediaManagement from "./assets/img/SocialMediaManagement.png";
import CMS from "./assets/img/CMS.png";
import caseStudyIco1 from "./assets/img/caseStudyIco-1.png";
const DigitalMarketing = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const initialSection = splitLocation[1] || "aiPowered";

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="innerPageIntroData aipageDataWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-5 sticyDiv padRightWrap">
                <div className="sticyDiv">
                  <div className="titleWrap">
                    <h2>Digital Marketing</h2>
                    <p>
                      Accelerate Your Journey to Digital Excellence with
                      Hummingtec Solutions
                    </p>
                  </div>
                  <div className="dataWrap">
                    <p>
                      At Hummingtec, we empower businesses to thrive in the
                      digital age with results-driven digital marketing
                      solutions, including SEO, social media, and campaign
                      management. Our expert team combines strategy, creativity,
                      and cutting-edge technology to boost brand awareness,
                      drive targeted website traffic, and convert visitors into
                      loyal customers. Whether you’re a startup or an
                      established enterprise, we craft custom marketing
                      campaigns aligned with your goals to maximize your online
                      presence and business growth.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <ul className="aiMlList">
                  <li>
                    <div className="itemWrap clr1">
                      <Link to="/seo">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Search Engine Optimization (SEO)</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr2">
                      <Link to="/Sem">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Search Engine Marketing (SEM & PPC)</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr3">
                      <Link to="/SocialMediaManage">
                        <div className="imgWrap">
                          <img
                            src={SocialMediaManagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Social Media Marketing (SMM)</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr4">
                      <Link to="/cms">
                        <div className="imgWrap">
                          <img src={CMS} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Content Management System</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap clr4">
                      <Link to="/ContentMarketing">
                        <div className="imgWrap">
                          <img
                            src={CustomerEngagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Content Marketing</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr5">
                      <Link to="/EmailMarketing">
                        <div className="imgWrap">
                          <img src={CMS} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Email Marketing & Automation</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr6">
                      <Link to="/Cro">
                        <div className="imgWrap">
                          <img
                            src={WorkflowAutomation}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Conversion Rate Optimization (CRO)</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap clr1">
                      <Link to="/WebAnalytics">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Web Analytics & Reporting</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr2">
                      <Link to="/Orm">
                        <div className="imgWrap">
                          <img
                            src={SocialMediaManagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Online Reputation Management (ORM)</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr3">
                      <Link to="/CustomerEngagement">
                        <div className="imgWrap">
                          <img
                            src={CustomerEngagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Customer Engagement</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Transform Your Business with Hummingtec Solutions</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Embrace the digital future confidently with Hummingtec
                    Solutions. Our digital transformation services are your
                    gateway to becoming a more agile, efficient, and innovative
                    organization. Ready to embark on a transformative journey?
                    Contact us today to explore how we can elevate your business
                    in the digital age.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default DigitalMarketing;
